export default __webpack_public_path__ + "static/spiritual-christian-paul-3-f41cb8b6d4c00f2eb63cbeac95804319.jpg";